module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C635"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_231"
    }
  }, [_vm._v("CONTENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/04_Acknowle"
    }
  }, [_vm._v("ACKNOWLEDGMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/01_Introduc"
    }
  }, [_vm._v("Introduction: Backstory: Breaking Omertà")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/02_Chapter#page_7"
    }
  }, [_vm._v("1. Game Changer: The Role of "), _c('em', [_vm._v("The Sopranos ")]), _vm._v("in the Resurgence of HBO")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/03_Chapter#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Cinematic Television: The Education of David Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/04_Chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Disorganized Crime: Living Large in the Suburbs")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/05_Chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Situation Tragedy: A Midlife Crisis for the Gangster Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/06_Conclusi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Strategic Ambiguity: "), _c('em', [_vm._v("The Sopranos")]), _vm._v("’ Aftereffect")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_Works_Ci",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WORKS CITED")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_Subject",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUBJECT INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_Televisi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TELEVISION SERIES INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac5f719","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/01_Content.vue
// module id = 66
// module chunks = 0